import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";

// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import JoditEditor from "jodit-react";
import classNames from "classnames";
import { IDS, Website_Type } from "../../../utils/common";
import { getData } from "../../../utils/api";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getDimension, Select2Data } = useContext(Context);
  // const [imageFile, setImageFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    watch,
  } = useForm();
  const imageFile = watch("image");
  const selectedType = watch("type");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();

      sendData.append("name", data.name);
      sendData.append("sub_name", data.sub_name);
      sendData.append("type", data.type.value);
      sendData.append("image", data.image[0]);

      if (data.type.value === "Category") {
        sendData.append(
          "category_ids",
          JSON.stringify(data.category_ids.map((option) => option.value)),
        );
        // data.category_ids.forEach((item) => {
        //   sendData.append("category_ids[]", item.value);
        // });
      }

      if (data.type.value === "Product") {
        sendData.append(
          "product_ids",
          JSON.stringify(data.product_ids.map((option) => option.value)),
        );
        // data.product_ids.forEach((item) => {
        //   sendData.append("product_ids[]", item.value);
        // });
      }

      const response = await postData(`/masters/home-occassion`, sendData);

      setShowModal({
        code: response?.code,
        message: response?.message,
      });

      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };
  const GetAllCategory = async () => {
    const response = await getData(`/allcategories/${Website_Type?.Luxury}`);

    if (response?.success) {
      setCategories(await Select2Data(response?.data, "category_id"));
    }
  };

  const GetAllProduct = async () => {
    const response = await getData(`/all-products/${Website_Type?.Luxury}`);

    if (response?.success) {
      setProducts(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllCategory();
    GetAllProduct();
  }, []);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Home Occassion
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="text-center">
                      <Form.Label>Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Name"
                        className={classNames("", {
                          "is-invalid": errors?.name,
                        })}
                        {...register("name", {
                          required: "Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="text-center">
                      <Form.Label>Sub Name</Form.Label>
                    </div>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="sub_name"
                        placeholder="Sub Name"
                        className={classNames("", {
                          "is-invalid": errors?.sub_name,
                        })}
                        {...register("sub_name", {
                          required: "Sub Name is required",
                        })}
                      />
                    </InputGroup>
                    {errors.sub_name && (
                      <span className="text-danger">
                        {errors.sub_name.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Group>
                    <div className="text-center">
                      <Form.Label>Image</Form.Label>
                    </div>
                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.image,
                        })}
                        type="file"
                        {...register("image", {
                          required: "Image is required",
                        })}
                        accept=".jpg, .jpeg, .png"
                      />
                    </Form.Group>
                    {errors.image && (
                      <span className="text-danger">
                        {errors.image.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>
              <Col className="main-form-section my-3">
                <div className="main-form-section my-3">
                  <Form.Label> Image Preview</Form.Label>

                  {imageFile && imageFile?.length > 0 && (
                    <div className="image-preview-container">
                      <img
                        src={URL.createObjectURL(imageFile[0])}
                        alt="Preview"
                        className="image-preview"
                        style={{ width: "150px", height: "130px" }}
                      />
                    </div>
                  )}
                </div>
              </Col>

              <Col md={6}>
                <div className="main-form-section my-3">
                  <Form.Label>Type</Form.Label>

                  <Controller
                    name="type"
                    control={control}
                    rules={{ required: "Type is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={[
                          { label: "Category", value: "Category" },
                          { label: "Product", value: "Product" },
                        ]}
                        placeholder="Select Type"
                      />
                    )}
                  />

                  {errors.type && (
                    <span className="text-danger">{errors.type.message}</span>
                  )}
                </div>
              </Col>

              {selectedType?.value === "Category" && (
                <Col md={6}>
                  <div className="main-form-section my-3">
                    <Form.Label>Categories</Form.Label>

                    <Controller
                      name="category_ids"
                      control={control}
                      rules={{ required: "Select at least one category" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={categories}
                          isMulti
                          placeholder="Select Categories"
                        />
                      )}
                    />

                    {errors.category_ids && (
                      <span className="text-danger">
                        {errors.category_ids.message}
                      </span>
                    )}
                  </div>
                </Col>
              )}

              {selectedType?.value === "Product" && (
                <Col md={6}>
                  <div className="main-form-section my-3">
                    <Form.Label>Products</Form.Label>

                    <Controller
                      name="product_ids"
                      control={control}
                      rules={{ required: "Select at least one product" }}
                      render={({ field }) => (
                        <Select
                          {...field}
                          options={products}
                          isMulti
                          placeholder="Select Products"
                        />
                      )}
                    />

                    {errors.product_ids && (
                      <span className="text-danger">
                        {errors.product_ids.message}
                      </span>
                    )}
                  </div>
                </Col>
              )}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
